export class MapLayerConfiguration {
  readonly id: number;
  name: string;
  url: string;
  configuration: string;
  routeConfigurationId: number;
  order: number;
  type: MapLayerType;
  source: MapLayerSource;
  enabled: boolean;
  username: string;
  password: string;
  opacity: number;
  useAsBaseMap: boolean;
  publicEnabled?: boolean;
  publicOrder?: number;

  useCredentials: boolean;

  // preview support
  checked = true;
  disabledOnPreview = false;
}

export enum MapLayerType {
  RASTER = 'RASTER',
  VECTOR = 'VECTOR',
  ROUTE = 'ROUTE',
}

export enum MapLayerSource {
  // XYZ tile URL
  TileUrl = 'TileUrl',
  // MapLibre RAW layers array configuration:
  // LineLayerSpecification | FillLayerSpecification | SymbolLayerSpecification | CircleLayerSpecification
  MapLibreConfig = 'MapLibreConfig',
  // WMS format that uses {bbox-epsg-3857}
  ArcGisExport = 'ArcGisExport',
  // Layer created by Route Configuration Import
  RouteImport = 'RouteImport',
}
